import { fg } from '@atlaskit/platform-feature-flags';

import type { FieldId } from '../../types/field';
import type { FieldChangesMapPublic } from '../../types/fields/field-changes';

export type LastProcessedChange = {
	fieldId: FieldId;
	changeId: string;
};

/**
 * Checks if the same field value was changed based on feature flag, fields changes,
 * and last processed change information.
 *
 * @param fieldsChanges - Map of field changes
 * @param lastProcessedChange - Information about the last processed change
 * @param changeId - Current change ID to compare against
 * @returns boolean indicating if the same field value was changed
 */
export function checkSameFieldValueChanged(
	fieldsChanges: FieldChangesMapPublic | undefined,
	lastProcessedChange: LastProcessedChange | null,
	changeId: string,
): boolean {
	if (
		// eslint-disable-next-line @atlaskit/platform/no-preconditioning
		fg('ditto_uim_new_attributes_for_uim_use_submit') &&
		fieldsChanges &&
		lastProcessedChange?.changeId === changeId
	) {
		const fid = lastProcessedChange?.fieldId;
		const change = fieldsChanges[fid];
		return !!change && change.hasOwnProperty('value');
	}

	return false;
}
